import { PaymentOption } from 'src/app/shared/constants/paymentOptions';
import {
  CAJA_FLOW_TYPE_CREATE,
  HIRER_PURCHASE_TYPE_CASUAL,
} from 'src/app/shared/constants/tealium';
import { log } from 'src/app/utils/logging';
import { WorkArrangement } from 'src/graphql/generated';
import type { Tealium } from 'src/types/appState';
import { CajaWorkType } from 'src/types/cajaWorkType';

export const defaultCompleteTrackingData: Tealium = {
  adBudgetPurchased: undefined,
  advertiser: {
    type: undefined,
    pricingType: undefined,
  },
  adBudgetValue: undefined,
  addOnAdProductNames: [],
  autoClassifyCategoryChosen: undefined,
  autoClassifyCategorySuggested: undefined,
  cajaAboutBusinessCharacterCount: undefined,
  cajaFlowType: CAJA_FLOW_TYPE_CREATE,
  cajaHasAIAssistanceBeenUsed: false,
  cajaPayType: undefined,
  cajaSalaryCurrency: undefined,
  cajaWorkType: CajaWorkType.FullTime,
  cajaWorkplaceOption: WorkArrangement.ONSITE,
  contractProductName: undefined,
  contractProductSetProductId: undefined,
  country: undefined,
  discountCode: undefined,
  displayPay: true,
  draftId: undefined,
  emailAddressVerified: false,
  experiments: undefined,
  finalJobSummaryCharacterCount: undefined,
  hasCoverImage: false,
  hasLogo: false,
  hasSeenSuccess: false,
  hasSufficientBudget: false,
  hasWorkplaceOption: true,
  hirerAdPurchaser: undefined,
  hirerContract: {
    adType: undefined,
    value: undefined,
    balance: undefined,
    type: undefined,
  },
  hirerInfo: {
    firstName: undefined,
    lastName: undefined,
    emailAddress: undefined,
  },
  hirerPurchaseType: HIRER_PURCHASE_TYPE_CASUAL,
  hubbleExperiments: undefined,
  isLinkOutApplyViaSeek: null,
  isOnCreditHold: false,
  isPaidByStoredCreditCard: false,
  isPayment: false,
  isPremiumAdOffered: false,
  isPrivateAd: false,
  isSaveCreditCardChecked: false,
  jobAdClassification: undefined,
  jobAdPostedWithRR: undefined,
  jobAdSubClassification: undefined,
  jobAdTypePosted: undefined,
  jobAdTypeSelected: undefined,
  numberOfBenefits: 0,
  numberOfQualifications: 0,
  numberOfTasks: 0,
  orderNumber: undefined,
  page: undefined,
  productPricing: [
    {
      position: undefined,
      id: undefined,
      price: undefined,
      currency: undefined,
      type: undefined,
      priceHidden: undefined,
    },
  ],
  productSetId: undefined,
  paymentMediumSelected: undefined,
  paymentMethod: PaymentOption.CREDIT_CARD,
  previousPageName: undefined,
  priceVisibility: 'hidden',
  productSetProductIds: [],
  productTotalPrice: undefined,
  recommendedSalaryRange: undefined,
  roleTitle: undefined,
  rrNumberOfQuestions: 0,
  rrQuestionIds: undefined,
  salaryRangeSelected: false,
  seekAdvertiserId: undefined,
  seekListingId: undefined,
  sourceJobId: undefined,
  testingId: undefined,
  userId: undefined,
};

export const getFromReduxPersist = () => {
  try {
    // TODO: Deprecate and remove this when migration to session storage is complete
    // This is required to satisfy the current tracking adapter implementation and type constraint
    // As we migrate from redux to session storage, SessionTrackingData should capture most of the data and can be used in place of Tealium
    const persistedState = localStorage.getItem(
      'persist:seek_caja_express:store',
    );
    return typeof persistedState === 'string'
      ? (JSON.parse(JSON.parse(persistedState).tealium) as Tealium)
      : defaultCompleteTrackingData;
  } catch (error) {
    log.error('getFromReduxPersist', { error });
    return defaultCompleteTrackingData;
  }
};
